<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #FormasPago
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 140px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Formas de Pago
    v-dialog(v-model='dialog', persistent max-width='700px')
          v-btn.mb-2(slot='activator', style="border-radius:5px;background-color:#2c489e;") Nueva Forma de Pago
          v-container(style='background-color:white !important;max-width: 700px;')
            v-card-title.justify-center
                span.headline Forma de Pago
            div(style="margin-top: 20px;")
                v-flex(xs12, sm12, md12)
                    v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                        v-flex(xs12, md6, sm6)
                          v-form(enctype="multipart/form-data")

                            v-text-field(outline
                            v-model="form.descripcion"
                            prepend-inner-icon="description"
                            label="Descripción:")

                            v-text-field(outline
                            v-model="form.numeroGrupo"
                            prepend-inner-icon="format_list_numbered"
                            label="Número de Grupo:"
                            type="number")

                            v-text-field(outline
                            v-model="form.dias"
                            prepend-inner-icon="date_range"
                            label="Días:"
                            type="number")

                            v-switch(
                              v-model="form.activo"
                              label="Activo"
                              color="primary"
                            )

                            div
                              v-flex(v-if="loading === true", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                  v-progress-circular(indeterminate='', color='primary')
                              v-flex(v-if="loading === false", xs12 sm12 md12)
                                v-layout(align-start='', justify-center='', row='', wrap fill-height='')
                                    v-btn(style="background:#2c489e;border-radius:10px;", @click.native='save') Guardar
                                    v-btn(style="background:black;border-radius:10px;", @click.native='close') Salir
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12 style='margin-top: 5px;')
        v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
            v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                span.white--text Lista de Formas de Pago
        v-data-table.elevation-1(:headers='headers', :items="resultados", style="margin-top: 5px;")
          template(slot='items', slot-scope='props')
            td {{ props.item.descripcion }}
            td {{ props.item.numeroGrupo }}
            td {{ props.item.dias }}
            td {{ props.item.activo ? 'Sí' : 'No' }}
            td
                v-btn.mx-0(icon, @click='editItem(props.item)')
                    v-icon(color='teal') edit
                v-btn.mx-0(icon, @click='deleteItem(props.item)')
                    v-icon(color='pink') delete
</template>

<script>
import Api from "@/services/methods";

export default {
  name: "FormasPago",
  data: () => ({
    loading: false,
    dialog: false,
    editedIndex: -1,
    resultados: [],
    headers: [
      { text: "Descripción", value: "descripcion" },
      { text: "Número de Grupo", value: "numeroGrupo" },
      { text: "Días", value: "dias" },
      { text: "Activo", value: "activo" },
      { text: "Acción", sortable: false }
    ],
    form: {
      descripcion: "",
      numeroGrupo: "",
      dias: "",
      activo: true
    },
    defaultForm: {
      descripcion: "",
      numeroGrupo: "",
      dias: "",
      activo: true
    },
  }),
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      this.loading = true;
      Api.get("formaspago").then(res => {
        this.resultados = res.data;
        this.loading = false;
      }).catch(err => {
        console.log(err);
        this.loading = false;
      });
    },
    close() {
      this.form = Object.assign({}, this.defaultForm);
      this.dialog = false;
    },
    editItem(item) {
      this.editedIndex = this.resultados.indexOf(item);
      this.form = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.$swal.fire({
          title: "¿Estás seguro?",
          text: "No podrás revertir esta operación!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si, Eliminar!"
        }).then(result => {
          if (result.value) {
            Api.delete("formaspago/" + item._id).then(res => {
                this.$swal.fire("Eliminado", "Registro eliminado.", "success");
                this.initialize();
            }).catch(err => {
                console.log(err);
                this.$swal.fire("Error", "No se pudo eliminar el registro.", "error");
            });
          }
        });
    },
    save() {
      this.loading = true;
      if (this.editedIndex > -1) {
        Api.put("formaspago", this.form).then(res => {
            this.loading = false;
            this.close();
            this.initialize();
            this.$swal.fire("Guardado", "Registro actualizado exitosamente.", "success");
        }).catch(err => {
            this.loading = false;
            console.log(err);
            this.$swal.fire("Error", "No se pudo actualizar el registro.", "error");
        });
      } else {
        Api.post("formaspago", this.form).then(res => {
            this.loading = false;
            this.close();
            this.initialize();
            this.$swal.fire("Guardado", "Registro guardado exitosamente.", "success");
        }).catch(err => {
            this.loading = false;
            console.log(err);
            this.$swal.fire("Error", "No se pudo guardar el registro.", "error");
        });
      }
    }
  }
};
</script>

<style scoped>
</style>
